<template>
  <div id="contenedor-agregar-proyecto-comentario">
    <template
      v-if="tipo === 'bloque'">
      <CustomTextArea
        v-model="comentario.comentario">
      </CustomTextArea>
      <v-btn
        @click="guardar"
        block>
      </v-btn>
    </template>
    <template
      v-if="tipo === 'chat'">
      <v-text-field
        v-model="comentario.comentario"
        filled
        rounded
        hide-details
        placeholder="Comentario..."
        prepend-inner-icon="mdi-comment-text"
        append-icon="mdi-send"
        @click:append="guardar"
        v-on:keyup.enter="guardar"
        >
      </v-text-field>
    </template>
  </div>
</template>

<script>
import CustomTextArea from '@/components/inputs/sinColumnas/TextArea.vue';
import mixProyectoComentarios from './mixProyectoComentarios';

export default {
  name: 'AgregarProyectoComentario',
  mixins: [mixProyectoComentarios],
  components: {
    CustomTextArea,
  },
  props: {
    idProyecto: {
      type: String,
      required: true,
    },
    tipo: {
      type: String,
      required: true,
    },
    idRespuesta: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      formularioValido: false,
      comentario: {
        idProyecto: this.idProyecto,
        idRespuesta: null,
        comentario: null,
      },
    };
  },
  methods: {
    async guardar() {
      await this.mixGuardarProyectoComentario(this.comentario);
      this.comentario.comentario = null;
      this.comentario.idRespuesta = null;
    },
  },
  watch: {
    idRespuesta: {
      handler(idRespuesta) {
        this.comentario.idRespuesta = idRespuesta;
      },
    },
  },
};
</script>

<style lang="scss">

</style>
